import { render, staticRenderFns } from "./TitleDetailProductionNewsBlockV1.vue?vue&type=template&id=69885a1a&scoped=true"
import script from "./TitleDetailProductionNewsBlockV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailProductionNewsBlockV1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailProductionNewsBlockV1.vue?vue&type=style&index=0&id=69885a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69885a1a",
  null
  
)

export default component.exports